'use client';

import { useEffect } from 'react';
import { useClientNameContext } from '../../contexts/ClientNameContext';
import { tooltipStore } from '../stores/tooltipStore';

/**
 * Syncs the browser language into the tooltip store's audience context.
 * Call once in the app (e.g. Onboarding) so that audience-targeted tooltips
 * (e.g. language: ['ja-JP']) are evaluated against the actual browser locale.
 * Also responds to the rare `languagechange` browser event.
 */
export function useSyncTooltipAudienceContext() {
  useEffect(() => {
    tooltipStore.setAudienceContext({ browserLanguage: navigator.language });

    const handleChange = () => {
      tooltipStore.setAudienceContext({ browserLanguage: navigator.language });
    };

    addEventListener('languagechange', handleChange);
    return () => removeEventListener('languagechange', handleChange);
  }, []);

  const clientName = useClientNameContext();

  useEffect(() => {
    tooltipStore.setAudienceContext({ clientName: clientName ?? null });
  }, [clientName]);
}
